var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavDiscardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36841 18.5263L3.36841 19.2105C3.36841 19.7628 3.81612 20.2105 4.36841 20.2105L27.6316 20.2105C28.1839 20.2105 28.6316 19.7628 28.6316 19.2105V4.36842C28.6316 3.81613 28.1839 3.36842 27.6316 3.36842L26.9474 3.36842V17.5263C26.9474 18.0786 26.4996 18.5263 25.9474 18.5263L3.36841 18.5263Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2632 0C24.8154 0 25.2632 0.447717 25.2632 1V15.8421C25.2632 16.3944 24.8154 16.8421 24.2632 16.8421L0.999998 16.8421C0.447713 16.8421 0 16.3944 0 15.8421V1C0 0.447716 0.447715 0 1 0H24.2632ZM12.6503 10.1241L16.9714 14.4452L18.7392 12.6774L14.4181 8.3563L18.5638 4.21054L16.7961 2.44277L12.6503 6.58853L8.50456 2.44277L6.73679 4.21054L10.8825 8.3563L6.56141 12.6774L8.32918 14.4452L12.6503 10.1241Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73682 21.8947L6.73682 22.5789C6.73682 23.1312 7.18453 23.579 7.73681 23.579H31C31.5523 23.579 32 23.1312 32 22.579V7.73684C32 7.18456 31.5523 6.73684 31 6.73684L30.3158 6.73684V20.8947C30.3158 21.447 29.868 21.8947 29.3158 21.8947L6.73682 21.8947Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDiscardIcon);
export default __webpack_public_path__ + "static/media/Nav-DiscardIcon.5d8086688526839909f9b13699788a48.svg";
export { ForwardRef as ReactComponent };